import React from "react";
export default function DIMS(){
  return (
    <div className="container mx-auto px-6 py-12">
      <h1 className="text-3xl font-bold">Drug Inventory Management System (DIMS)</h1>
      <p className="mt-4">RKbyte’s DIMS helps biotech labs track, manage, and monitor drug stocks with IoT integration, smart alerts, and real-time dashboards.</p>
      <ul className="list-disc ml-6 mt-4 space-y-2">
        <li>Automated stock tracking</li>
        <li>IoT-based temperature monitoring</li>
        <li>Barcode & RFID scanning</li>
        <li>AI-powered restocking alerts</li>
      </ul>
    </div>
  );
}
